import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    button: ['shop now - button'],
    sub_button: ['close - button'],
    coupon_button: ['coupon - button']
  }
};

const CouponBottomSheetTracking: FC = () => {
  var tracking = useSelector((state: any) => state.trackings.tracking);

  const style = `
.root_tracking {
    width: 100%;
    height: 100%;
    
    position: relative;
    background: none;
    overflow: hidden;
    
    .modal_wrapper {
      width: 100%;
      // height: 20.5rem;
      padding: 1rem 0 2rem 0;

      position: absolute;
      bottom: 0;
      overflow: hidden;
    }

    .close_btn {
      width: 100%;
      display: flex;
      justify-content: end;
    }
    .close_btn button {
      width: 1.5rem;
      height: 1.5rem;

      font-size: 0;
      border: none;
      background-color: transparent;
    }

    .contents_box {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.5rem;
    }
    .contents_box .title {
      width: 100%;
      min-height: 3rem;

      display: flex;
      align-items: center;
    }
    .title .title_inner {
      width: 100%;
      height: auto;
      max-height: 2.8rem;
    }

    .contents_box .middle {
      width: 100%;
      height: 100%;
      position: relative;
      overflow: hidden;
    }
    .middle .middle_left {
      width: 2rem;
      height: 2rem;
      position: absolute;
      top: 5rem;
      left: -1rem;

      border-radius: 2rem;
      border: 2px solid #323232;
      background-color: #fff;
    }
    .middle .middle_right {
      width: 2rem;
      height: 2rem;
      position: absolute;
      top: 5rem;
      right: -1rem;

      border-radius: 2rem;
      border: 2px solid #323232;
      background-color: #fff;
    }
    .middle .middle_top {
      height: 6rem;
      padding: 1rem;
    }
    .middle_top .middle_title {
      height: 1.5rem;
    }
    .middle_top .sub_title,
    .middle_top .date {
      height: 1.25rem;
    }

    .middle .middle_bottom {
      height: 3rem;
    }

    .btn_wrapper {
      width: 100%;
      height: 3rem;
    }

    .tracking_center {
        display: flex;
        align-items: center;
        justify-content: end;
    }
}
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }}></style>
      <div className="root_tracking">
        <div className="modal_wrapper">
          <div className="close_btn tracking_center">
            <EditTracking value={tracking?.sub_button?.[0]} type="sub_button" />
          </div>
          <div className="contents_box">
            <div className="title">
              <div className="title_inner"></div>
            </div>
            <div className="middle">
              <div className="middle_top">
                <p className="middle_title"></p>
                <p className="sub_title"></p>
                <p className="date"></p>
              </div>
              <div className="middle_bottom tracking_center">
                <p className="button">
                  <EditTracking
                    value={tracking?.coupon_button?.[0]}
                    type="coupon_button"
                  />
                </p>
              </div>
            </div>
            <div className="btn_wrapper tracking_center">
              <EditTracking value={tracking?.button?.[0]} type="button" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CouponBottomSheetTracking;
